import {types} from './customer.type';

export const updateCustomerInfo = (customerInfo) => {
  return {
    type: types.UPDATE_CUSTOMER_INFO,
    customerInfo,
  }
}